exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mc-1{\n  fill:#fff;\n  stroke:#707070;\n}\n\n.mc-2{\n  clip-path:url(#clip-path);\n}\n", ""]);
